import VisualAddition from "../../components/ClassOne/Mathematics/VisualAddition";
import WordAddition from "../../components/ClassOne/Mathematics/WordAddition";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/mathematics/addition/visual-problem", title: "Visual Problem", component: VisualAddition },
    { url: "/class-one/mathematics/addition/word-problem", title: "Word Problem", component: WordAddition },
];

export default topics;